<div>
	<div class="TopGrid">
		<label>Username:</label>
		<label class="InfoText">{{ Username }}</label>

		<label>Person:</label>
		<label class="InfoText">{{ PersonName }}</label>

		<label *ngIf="UserAdminManualEmail == true">Domain:</label>
		<div *ngIf="UserAdminManualEmail == true" class="DomainSelectGrid">
			<input [disabled]="IsLoading() == true" name="DomainOption" id="Dropdown" value="Dropdown" [(ngModel)]="DomainOption" type="radio" />
			<label for="Dropdown">From Dropdown</label>

			<input
				[disabled]="IsLoading() == true"
				name="DomainOption"
				id="Manual"
				value="Manual"
				[(ngModel)]="DomainOption"
				type="radio"
				style="margin-left: 10px"
			/>
			<label for="Manual">Enter Manually</label>
		</div>

		<label>Email:</label>

		<div *ngIf="DomainOption == 'Dropdown'" class="EmailGrid">
			<input [disabled]="IsLoading() == true" type="text" class="form-control" [(ngModel)]="Email" placeholder="ex. JDoe" />

			<label>&#64;</label>

			<p-dropdown
				[disabled]="IsLoading() == true"
				[options]="lstEmailDomain"
				[(ngModel)]="EmailDomain"
				optionLabel="EmailProviderEmailInfo"
				[filter]="true"
				filterBy="EmailProviderEmailInfo"
				[showClear]="false"
				placeholder="Select a school email domain"
			>
				<ng-template pTemplate="selectedItem">
					<div *ngIf="EmailDomain">
						<div class="form-control NoBorder" style="text-align: left">
							{{ EmailDomain.EmailProviderEmailInfo }}
						</div>
					</div>
				</ng-template>
				<ng-template let-EmailItem pTemplate="item">
					<div>
						<div class="form-control NoBorder" style="text-align: left">
							{{ EmailItem.EmailProviderEmailInfo }}
						</div>
					</div>
				</ng-template>
			</p-dropdown>
		</div>

		<input
			*ngIf="DomainOption == 'Manual'"
			[disabled]="IsLoading() == true"
			type="text"
			class="form-control"
			[(ngModel)]="Email"
			placeholder="ex. JDoe@Access411.com"
		/>
	</div>
</div>
